import React from "react";
import clsx from "clsx";

interface LoadingSpinnerProps {
  /** Optional CSS classes for layout or sizing */
  className?: string;
  /** Spinner size (default: md) */
  size?: "sm" | "md" | "lg";
  /** Optional accessible label */
  label?: string;
}

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  className,
  size = "md",
  label,
}) => {
  const sizeClasses = {
    sm: "h-4 w-4 border-[2px]",
    md: "h-8 w-8 border-[3px]",
    lg: "h-12 w-12 border-[4px]",
  }[size];

  return (
    <div
      className={clsx(
        "flex flex-col items-center justify-center",
        className
      )}
      role="status"
      aria-label={label ?? "Cargando..."}
    >
      <div
        className={clsx(
          "animate-spin rounded-full border-t-2 border-b-2 border-lifeguards-blue",
          sizeClasses
        )}
      />
      {label && (
        <span className="mt-2 text-sm text-gray-500">{label}</span>
      )}
    </div>
  );
};
